import React from "react";
import { Grid, Typography, Tooltip } from "@mui/material";
import { costBreakdownItems } from "./CostBreakdownItems";
import CostBreakdown from "../../deprecatedUikit/CostBreakdown/CostBreakdown";

interface BookingCostBreakdownProps {
  monthly: boolean;
  startDate: string;
  isBrokered: boolean;
  costData: Record<string, any> | null;
  calculatingCostData: boolean;
  displayCalculatedCostData?: boolean;
}

const titleSx = { marginBottom: '0.6rem' } as const;
const monthlyRecurringAmountSx = { marginTop: '1rem' } as const;
const errorSx = { fontWeight: '600', fontFamily: 'Inter', marginBottom: '1rem' } as const;

const BookingCostBreakdown = (props: BookingCostBreakdownProps) => {
  const {monthly, startDate, isBrokered, costData, calculatingCostData, displayCalculatedCostData = true} = props;

  // costBreakdownItems returns loosely-typed data that feeds the deprecated CostBreakdown component
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const costItems: any = costBreakdownItems(costData, startDate);

  return <Grid container className="ss-byb-cost-container">
    {monthly ? <>
      <Typography variant="h6" color={"textPrimary"} sx={titleSx}>Today&#39;s Payment Summary</Typography>
        <CostBreakdown items={costItems.firstCycleItems} includeTotal={false} loading={calculatingCostData} hideValue={!displayCalculatedCostData} />
        {
            isBrokered ?
                <Tooltip title="Does not include taxes or payment processor fees">
                    <Grid item>
                        <CostBreakdown items={costItems.brokeredMonthlyItems} total={costItems.brokeredInitialTotal} loading={calculatingCostData} hideValue={!displayCalculatedCostData} />
                    </Grid>
                </Tooltip>
            : <CostBreakdown items={costItems.monthlyItems} total={costItems.initialTotal} loading={calculatingCostData} hideValue={!displayCalculatedCostData} />
        }

        <Typography sx={monthlyRecurringAmountSx} variant="h6" color={"textPrimary"}>Monthly Payment Summary</Typography>
        <Typography sx={errorSx} variant="body2" component={"strong"} color='error'>
          This booking will renew automatically every Month until cancelled
        </Typography>

        {isBrokered ?
            <Tooltip title="Does not include taxes or payment processor fees">
                <Grid item>
                    <CostBreakdown items={costItems.brokeredMonthlySummary} total={costItems.brokeredRecurringTotal} loading={calculatingCostData} hideValue={!displayCalculatedCostData} />
                </Grid>
            </Tooltip>
            : <CostBreakdown items={costItems.monthlySummary} total={costItems.recurringTotal} loading={calculatingCostData} hideValue={!displayCalculatedCostData} />
        }
      </>
      :
        <>
        {isBrokered ?
            <Tooltip title="Does not include taxes or payment processor fees">
                <Grid item>
                    <CostBreakdown items={costItems.brokeredDailyItems} total={costItems.brokeredDailyTotal} loading={calculatingCostData} hideValue={!displayCalculatedCostData} />
                </Grid>
            </Tooltip>
            : <CostBreakdown items={costItems.dailyItems} total={costItems.dailyTotal} loading={calculatingCostData} hideValue={!displayCalculatedCostData} />
        }
        </>
    }
  </Grid>
};

export default BookingCostBreakdown;
